import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Tooltip from "@mui/material/Tooltip";

interface DeleteButtonProps {
  tooltipText?: string;
}

export function DeleteButton(props: DeleteButtonProps & IconButtonProps) {
  const { t } = useTranslation();
  const { tooltipText, ...iconButtonProps } = props;

  return (
    <Tooltip title={<div>{tooltipText || t("common.delete")}</div>}>
      <span>
        <IconButton {...iconButtonProps} size="large">
          <DeleteForeverIcon color={props.disabled ? "disabled" : "error"} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
